<!--
//================================================================================
// ID:BC006
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC006
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/09 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/10/18 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.02.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.03.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.04.00 | 2025/02/03 | 富士通Japan株式会社    | 令和6年度改修対応（2次リリース）
//================================================================================
-->
<template>
	<div class="contents__main--list">
		<error-message />
		<!--◆編集エリア START◆-->
		<div class="ichiran__main">
			<div class="ichiran__contents">
				<span class="contents__research">
					<label class="margin__right-5">条件を変更して検索</label>
					<input type="button" class="contents__btn--cancel" value="再検索" v-on:click="clickReSearchBtn()" tabindex="130">
				</span>
			</div>
			<pagination
				:name="'ページヘッダー'"
				:class="'margin__bottom-8'"
				:listCount="form.listCount"
				:displaySortFlg="true"
				:tabindex="1"
				:clickSortList="clickSortListBtn"
				:clickPageSwitch="clickPageSwitchBtn"
				:bairituVisibilityFlg="disp.listHideKbn == 2 || disp.listHideKbn == 4"
				:okiniiriVisibilityFlg="form.isAuthenticated"
				:akijyukoVisibilityFlg="disp.isAkijyuko"
				:sortType="[form.isOkiniiriSearch ? SORT_KIND.OKINIIRI : (form.bosyuKind.substring(2) == 4 ? SORT_KIND.ZUIJI : SORT_KIND.NORMAL)]"
				ref="pageHeader" />
			<div align="center">
				<div class="contents__div--PC">
				<table v-if="!form.isOkiniiriSearch" border="1" class="contents__table--itiran ichiran-back" id="list">
					<thead>
						<tr id="listheader">
							<th id="listtitle01">
								<a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a>
							</th>
							<th v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6" id="listtitle02">申込地区番号<br>
								<a v-if="disp.listHideKbn != 6" :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
							</th>
							<th v-else id="listtitle12">申込地区番号<br>
								<a v-if="disp.listHideKbn != 4 && disp.listHideKbn != 5" :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
							</th>
							<th v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6" id="listtitle03">
								<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
								<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
								<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
							</th>
							<th v-else-if="disp.isAkijyuko" id="listtitle33">
								<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
								<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
								<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
							</th>
							<th v-else-if="disp.listHideKbn == 2 || disp.listHideKbn == 4" id="listtitle13">
								<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
								<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
								<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></th>
							<th v-else id="listtitle23">
								<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
								<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
								<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></th>
							<th v-if="form.bosyuKind.substring(2) != 4" id="listtitle04">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集<br />戸数</a><br>
							</th>
							<th v-if="disp.isAkijyuko" id="listtitle30">空き<br />住戸数<br></th>
							<th v-if="form.bosyuKind.substring(2) == 4" id="listtitle04">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">残<br />戸数</a><br>
							</th>
							<th id="listtitle05">間取り<br>専用面積<br />(m&sup2;)</th>
							<th v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6" id="listtitle06">
								<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
								<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a><br>
								<a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a>
							</th>
							<th v-else id="listtitle06">
								<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
								<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a></th>
							<th id="listtitle07">
								<a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a>
							</th>
							<th v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6" id="listtitle08">
								<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
							</th>
							<th v-else-if="disp.isAkijyuko" id="listtitle28">
								<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
							</th>
							<th v-else id="listtitle18">
								<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
							</th>
							<th v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6" id="listtitle09">
								<a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a>
							</th>
							<th v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4" id="listtitle19">
								<a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考<br />倍率</a>
							</th>
							<th v-if="form.isAuthenticated" id="listtitle20">
								<a :href="disp.okiniiriLink" target="_blank" rel="noopener noreferrer" tabindex="-1" class="link-okiniiri"></a>
							</th>
							<th id="listtitle10"></th>
						</tr>
					</thead>
					<tbody>
						<tr id="listcountents" v-for="(row, index) in form.meisaiList" :key="row.noMouchiku">
							<td id="listtd">{{ row.nyukyoSu }}</td>
							<td id="listtd">{{ row.noMouchiku }}<br /><label v-if="disp.listHideKbn != 4 && disp.listHideKbn != 5 && disp.listHideKbn != 6">{{ row.kbYugu }}</label></td>
							<td id="listjyusho">
								<label id="list1">{{ row.jyutakuName }}</label><br />
								<label id="list2">{{ row.kusicyo }}</label><br />
								<label id="list3">{{ row.trans }}</label>
							</td>
							<td v-if="form.bosyuKind.substring(2) != 4" id="listtd">{{ row.nuBosyukosu }}</td>
							<td v-if="form.bosyuKind.substring(2) == 4" id="listtd">{{ row.zanKosu }}</td>
							<td v-if="disp.isAkijyuko" id="listtd">
								<label v-if="row.nuAkijyukosu != null && row.nuAkijyukosu != ''">{{ row.nuAkijyukosu }}</label>
								<label v-else>{{ disp.zenkakuHyphen }}</label>
							</td>
							<td id="listtd" class="contents__kaigyo--css">{{ row.madori }}<br />{{ row.senyoArea }}</td>
							<td id="listtd" v-if="row.kensetuLow == null && row.kensetuUpr == null">
								<label v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
									<br />{{ row.elevatorUmu }}<br />{{ row.jikotaisyo }}</label>
								<label v-else><br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-else-if="row.kensetuUpr == null">
								<label v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
									{{ row.kensetuLow }}<br />{{ row.elevatorUmu }}<br />{{ row.jikotaisyo }}</label>
								<label v-else>{{ row.kensetuLow }}<br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-else>
								<label v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
									{{ row.kensetuLow }}～<br />{{ row.kensetuUpr }}<br />{{ row.elevatorUmu }}<br />{{ row.jikotaisyo }}</label>
								<label v-else>{{ row.kensetuLow }}～<br />{{ row.kensetuUpr }}<br />{{ row.elevatorUmu }}</label>
							</td>
							<td id="listtd" v-if="row.moSiyoryoLow == null && row.moSiyoryoUpr == null">
								<label><br /></label>
							</td>
							<td id="listtd" v-else-if="row.moSiyoryoUpr == null">
								<label>{{ co_commaSeparated(row.moSiyoryoLow) }}</label>
							</td>
							<td id="listtd" v-else>
								<label>{{ co_commaSeparated(row.moSiyoryoLow) }}～<br />{{ co_commaSeparated(row.moSiyoryoUpr) }}</label>
							</td>
							<td id="listtdleft">{{ row.siyouEtc }}</td>
							<td id="listtdleft" v-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
								{{ row.jikonaiyo }}</td>
							<td id="listtd" v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4">
								<label v-if="row.nuBairitu != null && row.nuBairitu != ''">{{ row.nuBairitu }}</label>
								<label v-else>{{ disp.zenkakuHyphen }}</label>
							</td>
							<td v-if="form.isAuthenticated && row.fgOkiniiri == '0'" id="listtd" class="mark_okiniiri">
								<font-awesome-icon :icon="['far', 'heart']" v-on:click="clickOkiniiriBtn(row)" />
							</td>
							<td v-else-if="form.isAuthenticated && row.fgOkiniiri == '1'" id="listtd" class="mark_okiniiri mark_okiniiri-zumi">
								<font-awesome-icon :icon="['fas', 'heart']" v-on:click="clickOkiniiriBtn(row)" />
							</td>
							<td id="listtd">
								<input
									type="button"
									class="contents__btn--confirm mobile_detail_btn"
									value="選択"
									v-on:click="clickSelectDetailBtn(row)"
									:tabindex="String(Number(12) + (2*index))"/>
							</td>
						</tr>
					</tbody>
				</table>
				<table v-else border="1" class="contents__table--itiran ichiran-back" id="list">
					<thead>
						<tr id="listheader">
							<th id="listtitle01">
								募集の種類
							</th>
							<th id="listtitle02" style="width: 10%">住宅の種別<br>
							</th>
							<th id="listtitle03" style="width: 15%">
							<a v-bind:href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
							<a v-bind:href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
							<a v-bind:href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
							</th>
							<th id="listtitle04">
								<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集戸数</a>
							</th>
							<th id="listtitle20" style="padding-left: 10px;padding-right: 10px;font-size: 1.4em;">
								<a :href="disp.okiniiriLink" target="_blank" rel="noopener noreferrer" tabindex="-1" class="link-okiniiri" ></a>
							</th>
							<th id="listtitle10"></th>
						</tr>
					</thead>
					<tbody>
						<tr id="listcountents" v-for="(row, index) in this.form.meisaiList" v-bind:key="row.viewNoMouchiku">
							<td id="listtd">{{ row.nmBosyu }}</td>
							<td id="listtd">{{ row.nmZyutaku }}</td>
							<td id="listjyusho">
							<label id="list1">{{ row.jyutakuName }}</label><br />
							<label id="list2">{{ row.kusicyo }}</label><br />
							<label id="list3">{{ row.trans }}</label>
							</td>
							<td id="listtd">{{ row.dispBosyukosu }}</td>
							<td v-if="row.fgOkiniiri == '0'" id="listtd" class="mark_okiniiri">
								<font-awesome-icon :icon="['far', 'heart']" v-on:click="clickOkiniiriBtn(row)" />
							</td>
							<td v-if="row.fgOkiniiri == '1'" id="listtd" class="mark_okiniiri mark_okiniiri-zumi">
								<font-awesome-icon :icon="['fas', 'heart']" v-on:click="clickOkiniiriBtn(row)" />
							</td>
							<td id="listtd">
								<input
									type="button"
									class="contents__btn--confirm mobile_detail_btn"
									value="選択"
									v-on:click="clickSelectDetailBtn(row)"
									:tabindex="String(Number(12) + (2*index))"/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="contents__div--MOBILE">
				<table v-if="!form.isOkiniiriSearch" class="contents__table--stripe contents__even">
					<tbody>
						<tr class="contents__input--tr" v-for="(row, index) in form.meisaiList" :key="row.noMouchiku">
							<td class="contents__kaigyo--css">
								<label>
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a>
								</label>:{{ row.jyutakuName }}<br />
								<label>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a>
								</label>:{{ row.kusicyo }}<br />
								<label>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</label>:{{ row.trans }}<br />
								<span v-if="disp.isAkijyuko">
									<label>空き住戸数</label>
									<span v-if="row.nuAkijyukosu != null && row.nuAkijyukosu != ''">:{{ row.nuAkijyukosu }}</span>
									<span v-else>:{{ disp.zenkakuHyphen }}</span>
								<br />
								</span>
								<label>間取り</label>:{{ row.madori }}<br />
								<label>専用面積(m&sup2;)</label>:{{ row.senyoArea }}<br />
									<span v-if="row.kensetuLow == null && row.kensetuUpr == null">
								<label>
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a>
								</label>:<br />
								</span>
								<span v-else-if="row.kensetuUpr == null">
								<label>
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a>
								</label>:{{ row.kensetuLow }}<br />
								</span>
								<span v-else>
								<label>
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a>
								</label>:{{ row.kensetuLow }}～{{ row.kensetuUpr }}<br />
								</span>
								<span v-if="disp.listHideKbn == 2 || disp.listHideKbn == 4">
								<label>
									<a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考倍率</a>
								</label>
								<span v-if="row.nuBairitu != null && row.nuBairitu != ''">:{{ row.nuBairitu }}</span>
								<span v-else>:{{ disp.zenkakuHyphen }}</span>
								<br />
								</span>
								<span v-else-if="disp.listHideKbn == 1 || disp.listHideKbn == 6">
								<label>
									<a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a>
								</label>:{{ row.jikotaisyo }}<br />
								<label>
									<a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a>
								</label>:{{ row.jikonaiyo }}<br />
								</span>
								<label v-if="form.bosyuKind.substring(2) == 4">
									<a :href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">残戸数</a>
								</label>
								<label v-if="form.bosyuKind.substring(2) == 4">:{{ row.zanKosu }}</label><br />
								<span class="btn_detail">
									<a v-if="form.isAuthenticated && row.fgOkiniiri == '0'"
										class="contents__btn--favorite-mi btn_okiniiri"
										v-on:click="clickOkiniiriBtn(row)"
										:tabindex="Number(0) < index ? String(Number(11) + (2*index)) : String(Number(11) + 1)">
										お気に入り未登録
									</a>
									<a v-else-if="form.isAuthenticated && row.fgOkiniiri == '1'"
										class="contents__btn--favorite-zumi btn_okiniiri"
										v-on:click="clickOkiniiriBtn(row)"
										:tabindex="Number(0) < index ? String(Number(11) + (2*index)) : String(Number(11) + 1)">
										お気に入り登録済
									</a>
									<input
										type="button"
										class="contents__btn--confirm mobile_detail_btn"
										value="詳細"
										v-on:click="clickSelectDetailBtn(row)"
										:tabindex="String(Number(12) + (2*index))"/>
								</span><br/>
								<br/>
							</td>
						</tr>
					</tbody>
				</table>
				<table v-else class="contents__table--stripe contents__even">
					<tbody>
						<tr class="contents__input--tr" v-for="(row, index) in this.form.meisaiList" v-bind:key="row.viewNoMouchiku">
							<td class="contents__kaigyo--css">
								<label>募集の種類
								</label>:{{ row.nmBosyu }}<br />
								<label>住宅の種別
								</label>:{{ row.nmZyutaku }}<br />
								<label>
									<a v-bind:href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a>
								</label>:{{ row.jyutakuName }}<br />
								<label>
									<a v-bind:href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a>
								</label>:{{ row.kusicyo }}<br />
								<label>
									<a v-bind:href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</label>:{{ row.trans }}<br />
								<label >
									<a v-bind:href="disp.kosuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">募集戸数</a>
								</label>
								<label >:{{ row.dispBosyukosu }}</label><br />
								<span class="btn_detail">
									<a v-if="row.fgOkiniiri == '0'"
										class="contents__btn--favorite-mi btn_okiniiri"
										v-on:click="clickOkiniiriBtn(row)"
										:tabindex="Number(0) < index ? String(Number(11) + (2*index)) : String(Number(11) + 1)">
										お気に入り未登録
									</a>
									<a v-else-if="row.fgOkiniiri == '1'"
										class="contents__btn--favorite-zumi btn_okiniiri"
										v-on:click="clickOkiniiriBtn(row)"
										:tabindex="Number(0) < index ? String(Number(11) + (2*index)) : String(Number(11) + 1)">
										お気に入り登録済
									</a>
									<input
										type="button"
										class="contents__btn--confirm mobile_detail_btn"
										value="詳細"
										v-on:click="clickSelectDetailBtn(row)"
										:tabindex="String(Number(12) + (2*index))"/>
								</span><br/>
								<br/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<pagination
				:name="'ページフッター'"
				:class="'margin__top-10 margin-bottom-foot'"
				:listCount="form.listCount"
				:displaySortFlg="true"
				:displayFotterFlg="true"
				:tabindex="120"
				:clickSortList="clickSortListBtn"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageFotter" />
			</div>
		</div>
    <!--◆編集エリア END◆-->
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import Pagination from '@/components/Pagination.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { co_toTop, co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { HTTP_STATUS, SORT_KIND, DIALOG_BUTTON_LIST_KEY, ZENKAKU_HYPHEN } from '@/const/const.js';
import { STORE_DATA_ADD_DATA, STORE_DATA_GETDATA, STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS,
			STORE_VIEW_GET_SORT_ORDER, STORE_VIEW_GET_PARAMS, STORE_USER_IS_AUTHENTICATED } from '@/const/store.js';
import { PATH_BC006, PATH_BC006_EDIT_OKINIIRI } from '@/const/route.js';

export default {
	name: "BC006",
	components: {
		'error-message': ErrorMessage,
		'pagination': Pagination,
	},
	data: function () {
		return {
			form: {
				bosyuKind: '',          // 募集の種類
				jyutakuKind: '',		// 住宅の種別
				nyukyoNinzu: '',		// 入居人数
				jyutakuName: '',        // 住宅名
				kubu: '',				// 区部
				shibu: '',				// 支部
				kushicyoList: [],		// 区市町リスト
				trans1: '',				// 主な交通機関１
				trans2: '',				// 主な交通機関２
				trans3: '',				// 主な交通機関３
				transList: [],			// 主な交通機関リスト
				keyword: null,			// キーワードを含む
				tohoMin: null,			// 徒歩時間
				busJyogai: '',			// バス利用の住戸を除く
				madori: '',				// 間取り
				madoriList: [],			// 間取りリスト
				senyoAreaFrom: null,	// 専用面積（From）
				senyoAreaTo: null,		// 専用面積（To）
				buidYears: '',			// 建設年度からの経過年数
				buidYearsFrom: '',		// 建設年度（From）
				buidYearsTo: '',		// 建設年度（To）
				buildYearsCd: '',		// 建設年度からの経過年数コード
				elevator: '',			// エレベーター
				barrierFree: '',		// バリアフリー
				kbYuguFlg: true,        // 優遇抽せんの制御フラグ
				yugu: '',               // 優遇抽せんの有無
				yuguList: [],           // 優遇抽せんの有無リスト
				bairituFlg: false,      // 参考倍率の制御フラグ
				bairitu: '',            // 参考倍率
				meisaiList: [],         // 募集住宅一覧リスト(表示用)
				listCount: 0,           // 募集住宅一覧件数
				souPageCnt: 0,          // 総ページ数
				hanyoCode: '',          // 汎用コード
				zikoUmu: '',			// 住居内で病死等があった住宅の有無
				zanKosu: '',			// 残戸数
				isOkiniiriSearch: false,// お気に入り検索フラグ（true：お気に入り検索、false：通常検索）
				isAuthenticated: false,	// ログイン認証済みフラグ
				kbMosikomiStatus: '0',	// 住宅変更時、世帯情報の申込み状況（0:申込み未、1:一時保存、2:申込み済）
				bosyuHoshiki: 0,		// 募集方式（1：毎月募集、2：定期募集（抽選方式）、3：定期募集（ポイント方式）、4：随時募集）
			},
			disp: {
				listHideKbn: 2,         // 一覧非表示区分(1:参考倍率、2：対象階・事故内容、3：優遇抽せん以外、4：参考倍率以外、5：全て、6：参考倍率、優遇抽せん)
				linkUrlList: [],        // 外部リンクURLリスト
				bosyuJyutakuList: [],   // 募集住宅情報リスト
				nyukyoLink: '',         // 入居人数外部リンク
				yuguLink: '',           // 優遇抽せんの有無外部リンク
				jyutakuLink: '',        // 住宅名外部リンク
				syozaitiLink: '',       // 代表的な所在地外部リンク
				transLink: '',          // 主な交通機関外部リンク
				buildLink: '',          // 建設年度外部リンク
				elevatorLink: '',       // エレベーター外部リンク
				shiyoryoLink: '',       // 使用料外部リンク
				shiyoLink: '',          // 仕様等外部リンク
				bairituLink: '',        // 参考倍率外部リンク
				taisyokaiLink: '',      // 対象階外部リンク
				jikoLink: '',           // 事故内容外部リンク
				okiniiriLink: '',       // お気に入り住宅リンク
				kosuLink: '',			// 戸数外部リンク
				zenkakuHyphen: '',		// 全角ハイフン
				isAkijyuko: false,		// 空き住戸数表示フラグ（True：表示する、False：表示しない）
			},
			co_commaSeparated: co_commaSeparated,
			SORT_KIND: SORT_KIND,
			ZENKAKU_HYPHEN: ZENKAKU_HYPHEN,
		}
	},
	mounted: async function () {
		await this.$nextTick();

		if (this.form.bosyuKind != '') {
			// フォーカス設定
			this.$refs.pageHeader.focus();
		}

	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// 前画面からのパラメータを設定
		let param = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC006');

		// 画面間パラメータを削除
		co_clearParam('BC006');

		let data = [];
		if (typeof param != 'undefined') {
			data = param.paramData;
			this.form.bosyuHoshiki = param.bosyuHoshiki;
		}
		if (data.length === 0) {

			// 状態管理（ストア）から前回情報を取得
			data = this.$store.getters[STORE_DATA_GETDATA]('BC006');

			if (data === null) {
				// 前回情報が存在しない場合、ログイン画面に遷移
				co_toTrans('BC001');
				return;
			}
		}

		this.form.bosyuKind = data.bosyuKind;
		this.form.jyutakuKind = data.jyutakuKind;
		this.form.nyukyoNinzu = data.nyukyoNinzu;
		this.form.jyutakuName = data.jyutakuName;
		this.form.kubu = data.kubu;
		this.form.shibu = data.shibu;
		this.form.kushicyoList = data.kushicyoList;
		this.form.trans1 = data.trans1;
		this.form.trans2 = data.trans2;
		this.form.trans3 = data.trans3;
		this.form.transList = data.transList;
		this.form.keyword = data.keyword;
		this.form.tohoMin = data.tohoMin;
		this.form.busJyogai = data.busJyogai;
		this.form.madori = data.madori;
		this.form.madoriList = data.madoriList;
		this.form.senyoAreaFrom = data.senyoAreaFrom;
		this.form.senyoAreaTo = data.senyoAreaTo;
		this.form.buidYears = data.buidYears;
		this.form.buidYearsFrom = data.buidYearsFrom;
		this.form.buidYearsTo = data.buidYearsTo;
		this.form.buildYearsCd = data.buildYearsCd;
		this.form.elevator = data.elevator;
		this.form.barrierFree = data.barrierFree;
		this.form.kbYuguFlg = data.kbYuguFlg;
		this.form.yugu = data.yugu;
		this.form.yuguList = data.yuguList;
		this.form.bairituFlg = data.bairituFlg;
		this.form.bairitu = data.bairitu;
		this.form.hanyoCode = data.hanyoCode;
		this.form.zikoUmu = data.zikoUmu;
		this.form.zanKosu = data.zanKosu;
		this.form.isOkiniiriSearch = data.isOkiniiriSearch;
		this.form.kbMosikomiStatus = data.kbMosikomiStatus;
		this.form.isAuthenticated = this.$store.getters[STORE_USER_IS_AUTHENTICATED];

		// 入力値保持
		this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC006', data: this.form });

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 住宅の種別が世帯向（一般募集住宅）※単身でも入居可能な住宅を含む、または
		// 若年夫婦・子育て世帯向（定期使用住宅・10年期限付）※２人以上の家族向のみ の場合
		if (this.form.jyutakuKind == '04' || this.form.jyutakuKind == '05') {
			this.disp.isAkijyuko = true;
		}
		let self = this;
		let listData = await co_post(PATH_BC006, this.form, function (res, handle) {

			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		if (listData == null || listData.jyutakuList.length == 0 ) {
			// 検索結果無し
			co_errorDialog(co_getMessage('E0014'), this.doPageBack);

			// ローディング表示終了
			self.$store.commit(STORE_VIEW_PROGRESS, false);
			return;
		}

		// 一覧表示項目制御

		// 募集の種類コード
		let boshuKindCode = this.form.bosyuKind.substring(2);
		// 住宅の種別汎用コード１
		let jyutakuHanyoCode = this.form.jyutakuKind;
		if (boshuKindCode == '1'){
			// 毎月募集の場合
			if (jyutakuHanyoCode == '24') {
				// 結婚予定者向（定期使用住宅・10年期限付 ※２人以上のみ）の場合
				this.disp.listHideKbn = 2;
			} else if (this.form.zikoUmu == '1') {
				// 住居内で病死等があった住宅の場合
				this.disp.listHideKbn = 1;
			} else {
				// 住居内で病死等があった住宅以外の場合
				this.disp.listHideKbn = 3;
			}
		} else if (boshuKindCode == '2' || boshuKindCode == '3'){
			// 定期募集の場合
			if (this.form.zikoUmu == '1') {
				// 住居内で病死等があった住宅の場合
				this.disp.listHideKbn = 1;
			} else {
				// 住居内で病死等があった住宅以外の場合
				if (jyutakuHanyoCode == '20') {
					// 世帯向（一般募集住宅・ポイント方式）の場合
					this.disp.listHideKbn = 4;
				} else if (jyutakuHanyoCode == '21') {
					// 世帯向（車いす使用者世帯向住宅・ポイント方式）の場合
					this.disp.listHideKbn = 5;
				} else if (jyutakuHanyoCode == '08') {
					// 単身者用車いす使用者向住宅（抽せん方式）の場合
					this.disp.listHideKbn = 3;
				} else {
					// 「住居内で病死等があった住宅」かつ「『ポイント方式』と付く住宅」以外の場合
					this.disp.listHideKbn = 2;
				}
			}
		} else {
			// 随時募集の場合
			if (this.form.zikoUmu == '1') {
				// 居室内で病死等があった住宅 ※２人以上の家族向のみの場合
				this.disp.listHideKbn = 6;
			} else {
				// 世帯向（一般募集住宅） ※２人以上の家族向のみの場合
				this.disp.listHideKbn = 5;
			}
		}

		// 外部リンク情報を一覧に設定
		this.disp.linkUrlList = listData.linkList;
		this.setLinkUrl();

		// 全角ハイフン設定
		this.disp.zenkakuHyphen = ZENKAKU_HYPHEN;

		// 募集住宅情報を一覧に設定
		if (!this.form.isOkiniiriSearch) {
			// 申込地区番号順（昇順）で並び替え
			this.disp.bosyuJyutakuList = this.doSortList('08',listData.jyutakuList);
		} else {
			// お気に入りの登録順で並び替え
			this.disp.bosyuJyutakuList = this.doSortList('15',listData.jyutakuList);
		}

		this.form.meisaiList = this.disp.bosyuJyutakuList;
		this.convertEmpty();
		this.form.listCount = this.form.meisaiList.length;

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	computed: {
		beforePageFlg: function () {
			if (this.form.souPageCnt <= 5) {
				return false;
			} else {
				return true;
			}
		},
		nextPageFlg: function () {
			if (this.form.souPageCnt <= 5) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {

		// 外部リンク設定処理
		setLinkUrl: function() {

			this.disp.nyukyoLink = this.disp.linkUrlList[0].nmCd
			this.disp.yuguLink = this.disp.linkUrlList[1].nmCd
			this.disp.jyutakuLink = this.disp.linkUrlList[2].nmCd
			this.disp.syozaitiLink = this.disp.linkUrlList[3].nmCd
			this.disp.transLink = this.disp.linkUrlList[4].nmCd
			this.disp.buildLink = this.disp.linkUrlList[5].nmCd
			this.disp.elevatorLink = this.disp.linkUrlList[6].nmCd
			this.disp.shiyoryoLink = this.disp.linkUrlList[7].nmCd
			this.disp.shiyoLink = this.disp.linkUrlList[8].nmCd
			this.disp.bairituLink = this.disp.linkUrlList[9].nmCd
			this.disp.taisyokaiLink = this.disp.linkUrlList[10].nmCd
			this.disp.jikoLink = this.disp.linkUrlList[11].nmCd
			this.disp.okiniiriLink = this.disp.linkUrlList[12].nmCd
			this.disp.kosuLink = this.disp.linkUrlList[13].nmCd
		},
		// 再検索ボタン押下処理
		clickReSearchBtn: function () {

			// 募集住宅検索画面に遷移
			co_toTrans('BC005');
		},
		// 並び替えボタン押下処理
		clickSortListBtn: function (sortType, startIndex, endIndex) {

			this.disp.bosyuJyutakuList = this.doSortList(sortType, this.disp.bosyuJyutakuList);
			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.bosyuJyutakuList[i]);
			}
			this.form.meisaiList = eitMeisaiList;
		},
		// 並び替え処理
		doSortList: function (sortType, dataList) {

			switch (sortType){
				case '01':
					dataList.sort( (a,b) => {
						if (a.nuToho !== b.nuToho) {
							return a.nuToho - b.nuToho;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '02':
					dataList.sort( (a,b) => {
						if (a.nuBosyukosu !== b.nuBosyukosu) {
							return b.nuBosyukosu - a.nuBosyukosu;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '03':
					dataList.sort( (a,b) => {
						if (a.nuSenyoLow !== b.nuSenyoLow) {
							return b.nuSenyoLow - a.nuSenyoLow;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '04':
					dataList.sort( (a,b) => {
						if (a.yyKensetuLow !== b.yyKensetuLow) {
							return b.yyKensetuLow - a.yyKensetuLow;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '05':
					dataList.sort( (a,b) => {
						if (a.moSiyoryoLow !== b.moSiyoryoLow) {
							return a.moSiyoryoLow - b.moSiyoryoLow;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '06':
					dataList.sort( (a,b) => {
						if (a.moSiyoryoUpr !== b.moSiyoryoUpr) {
							return a.moSiyoryoUpr - b.moSiyoryoUpr;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '07':
					dataList.sort( (a,b) => {
						if (a.nuBairitu !== b.nuBairitu) {
							return a.nuBairitu - b.nuBairitu;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;

				case '08':
					dataList.sort( (a,b) => {
						return Number(a.viewNoMouchiku - b.viewNoMouchiku);
					});
					break;
				// 残戸数 降順
				case '09':
					dataList.sort( (a,b) => {
						if (a.zanKosu !== b.zanKosu) {
							return b.zanKosu - a.zanKosu;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;
				// 残戸数 昇順
				case '10':
					dataList.sort( (a,b) => {
						if (a.zanKosu !== b.zanKosu) {
							return a.zanKosu - b.zanKosu;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;
				// 戸数 降順（お気に入り検索時）
				case '14':
					dataList.sort( (a,b) => {
						if (a.sortBosyukosu !== b.sortBosyukosu) {
							return b.sortBosyukosu - a.sortBosyukosu;
						}
						return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;
				// お気に入り登録日 昇順（お気に入り検索時）
				case '15':
					dataList.sort( (a,b) => {
						if (a.viewDtOkiniiri !== b.viewDtOkiniiri) {
							return a.viewDtOkiniiri - b.viewDtOkiniiri;
						}
						return a.viewNoMouchiku - b.viewNoMouchiku;
					});
					break;

				// 空き住戸数 降順
				case '16':
					dataList.sort( (a,b) => {
						if (a.nuAkijyukosu === null) {
							return 1;
						}
						if (b.nuAkijyukosu === null) {
							return -1;
						}
						if (a.nuAkijyukosu !== b.nuAkijyukosu) {
							return b.nuAkijyukosu - a.nuAkijyukosu;
						}
						return a.noMouchiku - b.noMouchiku;
					});
					break;
			}
			return dataList;
		},

		// ページ切替ボタン押下処理
		clickPageSwitchBtn: function (startIndex, endIndex) {

			let sortOrder = this.$store.getters[STORE_VIEW_GET_SORT_ORDER];
			if (sortOrder != '') {
				this.disp.bosyuJyutakuList = this.doSortList(sortOrder, this.disp.bosyuJyutakuList);
			}

			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.bosyuJyutakuList[i]);
			}
			this.form.meisaiList = eitMeisaiList;

			// ページトップへ遷移
			co_toTop();
		},
		// 選択(詳細)ボタン押下処理
		clickSelectDetailBtn: function (row) {

			let bosyuKind = this.form.bosyuKind;
			let jyutakuKind = this.form.jyutakuKind;
			let zikoUmu = this.form.zikoUmu;

			if (this.form.isOkiniiriSearch == true) {
				bosyuKind = row.kbBosyu + row.bosyuHosiki;
				jyutakuKind = row.kbZyutaku;
				zikoUmu = row.kbZiko;
			}

			// 募集住宅情報画面に遷移
			let params = {
							jyutakuInfo: row,
							bosyuKind: bosyuKind,
							jyutakuKind: jyutakuKind,
							zikoUmu: zikoUmu,
							isOkiniiriSearch: this.form.isOkiniiriSearch
						};
			co_toTrans('BC007', params);
		},
		// 検索結果無しダイアログ「OK」ボタン押下時処理
		doPageBack: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 募集住宅検索画面に遷移
				co_toTrans('BC005');
			}
		},
		// お気に入り登録／未登録ボタン押下処理
		clickOkiniiriBtn: async function (row) {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// お気に入り登録／未登録切り替え
			let params = {
							kbBosyu: row.kbBosyu,
							kbZyutaku: row.kbZyutaku,
							ymBosyu: row.ymBosyu,
							noMouchiku: row.noMouchiku,
							fgOkiniiri: row.fgOkiniiri
						};

			let self = this;
			let data = await co_post(PATH_BC006_EDIT_OKINIIRI, params, function (res, handle) {

				if (res.status == HTTP_STATUS.OK) {
					return handle(res);
				} else {
					// ローディング表示終了
					self.$store.commit(STORE_VIEW_PROGRESS, false);
				}
			});

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			if (data != null ) {
				if (data.result != "0" ) {
					// お気に入り登録／未登録切り替えエラー
					co_errorDialog(co_getMessage(data.errorMsgId, data.replaceItem), this.doOkiniiriErr);
					return;
				} else {
					// お気に入り登録／未登録切り替え完了
					// ボタンまたはマークの表示切り替え
					row.fgOkiniiri = data.fgOkiniiri;
					row.viewDtOkiniiri = data.viewDtOkiniiri;
				}
			}
		},
		// お気に入り登録／未登録切り替えエラーダイアログ「OK」ボタン押下時処理
		doOkiniiriErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 空文字変換処理
		convertEmpty: function () {

			for (let i = 0; i < this.form.meisaiList.length; i++) {
				let toho = this.form.meisaiList[i].nuToho;
				// 徒歩区分がNULLまたは空文字の場合
				if (co_isEmpty(toho) || toho == null) {
					this.form.meisaiList[i].nuToho = '99'
				}
			}
		}
	}
}
</script>

<style>

.btn_okiniiri {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	margin-right: 12px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__div--MOBILE {
		display: none;
	}

	.contents__main--list {
		margin-left: 0% !important;
		margin-right: 0% !important;
		margin-top: 70px;
	}

	.ichiran__main {
		margin: 8px;
	}

	.ichiran__contents {
		margin-bottom: 8px;
		margin-left: auto;
		text-align: right;
	}

	.contents__research {
		position: relative;
	}

	.ichiran-back {
		table-layout: fixed;
	}

	.ichiran-back tr:nth-child(even) {
		background-color: #f1f2f5;
	}
  
	#link {
		text-decoration: none;
	}
	#listjyusho {
		padding: 10px 7px;
	}
	#listodd {
		background-color: #eeeeee;
		text-align: senter;
	}

	/* 入居人数(ヘッダ) */
	#listtitle01 {
		width: 8%;
		font-size: 16px;
	}

	/* 申込地区番号(ヘッダ) */
	#listtitle02 {
		width: 8%;
		font-size: 16px;
		padding: 5px 0px;
		line-height: 22px;
	}
	#listtitle12 {
		width: 11%;
		font-size: 16px;
		padding: 5px 0px;
		line-height: 22px;
	}

	/* 住宅名(ヘッダ) */
	#listtitle03 {
		width: 23%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle13 {
		width: 24%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle23 {
		width: 28%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle33 {
		width: 22%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 募集戸数(ヘッダ) */
	#listtitle04 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 間取り(ヘッダ) */
	#listtitle05 {
		width: 9%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 建設年度(ヘッダ) */
	#listtitle06 {
		width: 11%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 使用料(ヘッダ) */
	#listtitle07 {
		width: 9%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 仕様等(ヘッダ) */
	#listtitle08 {
		width: 12%;
		font-size: 16px;
	}
	#listtitle18 {
		width: 16%;
		font-size: 16px;
	}
	#listtitle28 {
		width: 13%;
		font-size: 16px;
	}

	/* 参考倍率・事故内容(ヘッダ) */
	#listtitle09 {
		width: 12%;
		font-size: 16px;
	}
	#listtitle19 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 選択(ヘッダ) */
	#listtitle10 {
		width: 4%;
		font-size: 16px;
	}

	/* お気に入り(ヘッダ) */
	#listtitle20 {
		width: 4%;
		padding-left: 10px;
		padding-right: 10px;
		font-size: 1.5em;
	}

	/* 空き住戸数(ヘッダ) */
	#listtitle30 {
		width: 6%;
		font-size: 16px;
		line-height: 22px;
	}

	#list1 {
		font-weight: bold;
		font-size: 17px;
	}
	#list2 {
		font-weight: bold;
		font-size: 14px;
	}
	#list3 {
		font-size: 13px;
	}
	#listtdleft {
		text-align: left;
		font-size: 16px;
	}
	.mobile_detail_btn {
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.mark_okiniiri {
		padding-left: 10px;
		padding-right: 10px;
		font-size: 1.8em !important;
	}

	.mark_okiniiri-zumi {
		color: #FF1950;
	}

}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.ichiran__contents {
		margin-bottom: 8px;
		display: flex;
	}

	.ichiran__main {
		position: relative;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
		margin-top: 10px;
	}

	.contents__research {
		float: right;
		margin-right: 2%;
		margin: 0 0 8px auto;
	}

	.contents__list--page :nth-child(2) { order: 3; width: 100%; margin-bottom: 1%; text-align: right;}
	.contents__list--page :nth-child(3) { order: 4; width: 100%; margin-bottom: 1%; text-align: right;}

	.contents__div--PC {
		display: none;
	}

	#link {
		text-decoration: none;
	}

	.page_num {
		margin: 4px auto;
		clear: both;
		text-align: center;
		font-size: 15px;
	}
	.btn_detail {
		float: right;
		margin-right: 2%;
		margin-top: 5px;
	}
	.mobile_detail_btn {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.contents__even label {
		font-weight: bold;
	}
	.contents__even tr:nth-child(even) {
		background-color: #f1f2f5;
	}
}

/* 端末がスマホの場合（解像度367以下） */
@media screen and (max-width: 734px) {
	.btn_okiniiri {
		margin-right: 4px;
	}
}
</style>